import { AnimatePresence, motion } from "framer-motion";
import { useFormCtx } from "../FormContext";
const animationConfiguration = {
  initial: { x: "20%", opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: "-20%", opacity: 0, transition: { duration: 0.3 } },
};
const TransitionBlock = ({ children, delay = 0, className = "" }) => {
  const { currentBtnPageIndex } = useFormCtx();

  return (
    <motion.div
      key={currentBtnPageIndex}
      variants={animationConfiguration}
      initial="initial"
      animate="animate"
      className={className}
      exit="exit"
      transition={{ delay: delay, duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
};
export default TransitionBlock;
